// ================================================================================
// wp-block-slider.js
// スライダーのスクリプトファイル
// ================================================================================

import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';


window.addEventListener('load', () => {

	const swiper = new Swiper('.js-location-slider-swiper', {
		modules: [Autoplay, Navigation, Pagination],
		loop: true,
		slidesPerView: 1,
		autoplay: {
			delay: 2500, // 4秒ごとに切り替え（お好みで調整可）
			disableOnInteraction: false, // ユーザー操作後も自動再開したい場合
		},
		speed: 1000,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},

	});

} );
